module.exports = __webpack_public_path__ + "static/media/BoxPlotQ1_2.a3039816.svg";